import React, { useEffect, useState } from 'react'
import AppBar from '@mui/material/AppBar';
import HideOnScroll from './HideOnScroll';
import {Toolbar, Button, Grid, IconButton, Box, useMediaQuery} from '@mui/material';
import { GitHub, LinkedIn, Menu } from '@mui/icons-material';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Mode from './Mode';


function Navbar({darkMode, setDarkMode, ...props}) {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const [scroll, setScroll] = useState(0);
    useEffect(()=>{
        window.addEventListener('scroll', ()=>{
            setScroll(window.scrollY);
        })
        return ()=>window.removeEventListener('scroll', ()=>{
            setScroll(window.scrollY);
        });
    },[])

    const [state, setState] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
      });
    
      const toggleDrawer = (anchor, open) => (event) => {
        if (
          event &&
          event.type === 'keydown' &&
          (event.key === 'Tab' || event.key === 'Shift')
        ) {
          return;
        }
    
        setState({ ...state, [anchor]: open });
      };

      const list = (anchor) => (
        <Box
          sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
          role="presentation"
          onClick={toggleDrawer(anchor, false)}
          onKeyDown={toggleDrawer(anchor, false)}
        >
          <List>
            {['Home', 'About', 'Portfolio', 'Service', 'Testimonial', 'Tech Stack', 'Contact', 'Github', 'Linked In'].map((text, index) => (
              <>
                <ListItem key={text} disablePadding>
                  {
                    index === 7 && (
                      <ListItemButton href='https://www.github.com/sidul567' target='_blank'>
                        <ListItemIcon>
                          <GitHub />
                        </ListItemIcon>
                        <ListItemText primary={text} />
                      </ListItemButton>
                    )
                  }
                  {
                    index === 8 && (
                      <ListItemButton href='https://www.linkedin.com/in/sidul567' target='_blank'>
                        <ListItemIcon>
                          <LinkedIn />
                        </ListItemIcon>
                        <ListItemText primary={text} />
                      </ListItemButton>
                    )
                  }
                  {
                    index <= 6 && (
                      <ListItemButton href={`#${text.toLowerCase().split(' ').join('')}`}>
                        <ListItemText primary={text} />
                      </ListItemButton>
                    )
                  }
              </ListItem>
              <>
                  {
                    index < 8 && (
                      <Divider />
                    )
                  }
              </>
              </>
            ))}
          </List>
        </Box>
      );
  return (
    <HideOnScroll {...props}>
        <AppBar variant='outlined' elevation={0} sx={{background: scroll > 0 ? "#42446E" : "transparent", color: scroll > 0 ? "#ffffff" : "inherit"}}>
        <Toolbar sx={{'display': 'flex', 'justifyContent': 'flex-end'}}>
            <Box display={isSmallScreen ? 'none' : ''}>
                <Button variant='text' sx={{'textTransform': 'none', color: 'inherit'}} href='#home'>Home</Button>
                <Button variant='text' sx={{'textTransform': 'none', color: 'inherit'}} href="#about">About</Button>
                <Button variant='text' sx={{'textTransform': 'none', color: 'inherit'}} href="#portfolio">Project</Button>
                <Button variant='text' sx={{'textTransform': 'none', color: 'inherit'}} href="#service">Service</Button>
                <Button variant='text' sx={{'textTransform': 'none', color: 'inherit'}} href="#testimonial">Testimonial</Button>
                <Button variant='techstack' sx={{'textTransform': 'none', color: 'inherit'}} href="#techstack">Tech Stack</Button>
                <Button variant='text' sx={{'textTransform': 'none', color: 'inherit'}} href="#contact">Contact</Button>
                <IconButton
                    size="small"
                    color="inherit"
                    href='https://www.github.com/sidul567'
                    target='_blank'
                >
                    <GitHub />
                </IconButton>
                <IconButton
                    size="small"
                    color="inherit"
                    href='https://www.linkedin.com/in/sidul567'
                    target='_blank'
                >
                    <LinkedIn />
                </IconButton>
                <Mode />
            </Box>
            <Box display={!isSmallScreen ? 'none' : ''}>
                <Mode />
                <IconButton
                    size="medium"
                    color="inherit"
                    onClick={toggleDrawer("right", true)}
                >
                    <Menu />
                </IconButton>
                <SwipeableDrawer
                    anchor={"right"}
                    open={state["right"]}
                    onClose={toggleDrawer("right", false)}
                    onOpen={toggleDrawer("right", true)}
                >
                    {list("right")}
                </SwipeableDrawer>
            </Box>
        </Toolbar>
        </AppBar>
    </HideOnScroll>
  )
}

export default Navbar